import { createApp } from 'vue'
import { Toast } from 'vant'
import { Device, Env, Render, globalConfig, Url, GlobalInfo, Auth } from '@loca/mfe-vue3'
import Analytics from '@/core/Analytics'
import CopyMonitor from '@/core/CopyMonitor'
import { startMonitor } from '@/core/Analytics/performance'
import { fetchBackend } from '@/utils/fetch'
import App from './App.vue'
import { genRouter } from './router'
import mfeStart from './mfe'
import i18n, { t } from './i18n'
import '@/core/hack'
import 'vant/es/toast/style'
import envConfig from '@/utils/envConfig'
import '@/auth'
import startMfe from './mfe'
import { checkLogin } from '@/auth/login'

const { BASE_API } = envConfig

// 初始化 sdk 内的 fetch 函数
globalConfig.fetch = fetchBackend
// 初始化 url 中携带的 accessToken
Auth.initAccessToken()

Url.initStatusBarHeightStyle()
GlobalInfo.set('appId', 101797)
GlobalInfo.set('domain', BASE_API)
GlobalInfo.set('gatewayPath', '/pe/gatekeeper')
sessionStorage.setItem('wf_tenant_id', 'npds')

const defaultRelease = 'npds@' + require('../package.json').version

export async function renderApp() {
  // 初始化埋点统计
  Analytics.init({ enableXHRMonitor: false })
  // 性能统计
  startMonitor()

  let userRes: any
  if (window.location.pathname !== '/500') {
    Toast.loading({
      message: t('loading') as string,
      forbidClick: true,
      duration: 30000
    })

    const curWin = window as any
    curWin.mainAppToast = Toast

    // 若 url 中存在 token，则进行 jwt 登录流程
    await checkLogin()

    const ifErrorPage = window.location.pathname === '/error'
    // 若为跳转登录成功后返回，则回到登录前的页面
    if (!ifErrorPage) Url.redirecToFullpathAfterLogin('history')
    // 初始化用户信息等数据
    userRes = await Auth.initUserInfoWithCacheMode()
    // 判定是否继续加载后续页面
    if (
      (!ifErrorPage && userRes.resultCode === 'user_no_login') ||
      userRes.resultCode === 'auth_failed'
    ) {
      return
    }

    // 全局复制监听（由于内部有接口调用，可能会触发登录逻辑，因此放到此位置）。user/info接口必须是第一个调用的接口
    CopyMonitor.start()

    // 获取 user id 并进行埋点用户绑定
    try {
      const { userId } = userRes.data.data
      Analytics.login(userId)
    } catch {}
  }

  // 渲染页面
  const router = genRouter()
  const app = createApp(App)

  app.use(i18n).use(router).mount('#app')

  if (Device.isMobile()) {
    document.body.style.setProperty('--header-height', '44px')
  }

  // 开启微前端子应用渲染
  startMfe()

  app.config.compilerOptions.isCustomElement = (tag) => {
    return ['pg-icon'].includes(tag)
  }

  // 开启微前端子应用渲染
  mfeStart()


  if (Env.getEnv() === 'test') {
    // const vconsole = new VConsole()
  }

  // 在飞书外访问时，主动添加水印
  if (!Device.isFeishu()) {
    // 如果 url 上携带去水印参数，不加载水印（内嵌报告场景，多重水印会重叠）
    if(Url.getUrlSearch('closeWatermark') === 'true'){
      return
    }
    import('loca-watermark-core').then(({ watermark }) => {
      const { userId, userInfo } = userRes?.data || {}
      // 添加水印的第一行文字
      if (userId) watermark.load({ watermarkTxt: userId, watermarkTxtDes: userInfo?.email, })
    })
  }
}
